import Phaser from 'phaser';
import { createPhaserConfig } from './config';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { LevelSelectScene } from './scenes/LevelSelectScene';
import { SettingsScene } from './scenes/SettingsScene';
import { StatsScene } from './scenes/StatsScene';
import { GameScene } from './scenes/GameScene';
import { ResultsScene } from './scenes/ResultsScene';
import { VictoryScene } from './scenes/VictoryScene';
import { VerticalSliceScene } from './scenes/VerticalSliceScene';
import { initAnalytics } from './utils/analytics';
import {
  setupSafeAreaProperties,
  getDeviceInfo,
  setupMobileViewportHarness,
} from './utils/responsive';

// Initialize responsive utilities (safe areas)
setupMobileViewportHarness();
setupSafeAreaProperties();

// Log device info in development
if (import.meta.env.DEV) {
  console.log('Device info:', getDeviceInfo());
}

// Initialize analytics (tracks session start/end)
initAnalytics();

// Build config with scenes
const config: Phaser.Types.Core.GameConfig = {
  ...createPhaserConfig(Phaser),
  scene: [
    BootScene,
    TitleScene,
    LevelSelectScene,
    SettingsScene,
    StatsScene,
    GameScene,
    VerticalSliceScene,
    ResultsScene,
    VictoryScene,
  ],
};

// Initialize the game
const game = new Phaser.Game(config);

if (import.meta.env.DEV && typeof window !== 'undefined') {
  const w = window as unknown as {
    __game?: Phaser.Game;
    __sceneEvents?: Array<{ ts: number; scene: string }>;
    __missingTextures?: Array<{ ts: number; key: string }>;
    __fpsSamples?: Array<{ ts: number; fps: number }>;
    __getAssetManifest?: () => { textures: string[] };
  };

  w.__game = game;
  w.__sceneEvents = w.__sceneEvents ?? [];
  w.__missingTextures = w.__missingTextures ?? [];
  w.__fpsSamples = [];
  w.__getAssetManifest = () => ({
    textures: game.textures.getTextureKeys(),
  });

  game.textures.on(Phaser.Textures.Events.ERROR, (key: string) => {
    w.__missingTextures?.push({ ts: performance.now(), key });
    console.warn(`Missing texture: ${key}`);
  });

  window.setInterval(() => {
    if (!game.loop) return;
    w.__fpsSamples?.push({ ts: performance.now(), fps: game.loop.actualFps });
  }, 1000);
}

export default game;
